<template>
  <div class="productions page fixed-page">
    <div class="columns">
      <div class="column main-column">
        <div class="level page-header">
          <div class="level-left">
            <page-title :text="$t('timelog.title')" />
          </div>
        </div>
        <div class="datepickrow flexrow">
          <div class="flexrow-item">
            <p>{{ $t('timelog.arrange') }}</p>
            <combobox
              label=""
              :options="view_options"
              v-model="view_selected"
            />
          </div>
          <div class="flexrow-item">
            <p>{{ $t('timelog.start_date') }}</p>
            <datepicker
              :value="start_date"
              :disabled="view_selected === 'live'"
              wrapper-class="datepicker"
              input-class="date-input input"
              format="yyyy-MM-dd"
              v-model="start_selected"
            />
          </div>
          <div class="flexrow-item">
            <p>{{ $t('timelog.end_date') }}</p>
            <datepicker
              :value="end_date"
              :disabled="view_selected === 'live'"
              wrapper-class="datepicker"
              input-class="date-input input"
              format="yyyy-MM-dd"
              v-model="end_selected"
            />
          </div>
          <div class="flexrow-item">
            <p>{{ $t('main.production') }}</p>
            <combobox
              label=""
              :disabled="view_selected === 'live' || view_selected === 'attendance'"
              :options="prod_options"
              v-model="prod_selected"
            />
          </div>
          <div class="flexrow-item">
            <p>{{ $t('main.person') }}</p>
            <combobox
              label=""
              :disabled="view_selected === 'live'"
              :options="pers_options"
              v-model="pers_selected"
            />
          </div>
          <div class="flexrow-item">
            <p>{{ $t('timelog.show_todos') }}</p>
            <checkbox
              label=""
              :toggle=true
              :disabled="view_selected !== 'productions'"
              v-model="show_todos"
            />
          </div>
          <div class="flexrow-item">
            <p>{{ $t('timelog.print') }}</p>
            <button-simple
              icon="print"
              text=""
              @click="onPrintClick"
            />
          </div>
        </div>
        <div class="columns mainrow">
          <div
            id="table-area"
            class="table-area column"
          >

            <h2>
              {{ `${$t('timelog.title')}: ${bigDate(start_date)} - ${bigDate(end_date)}` }}
            </h2>
            <!-- <h3>UwU</h3> -->
            <h3>
              {{ secondHead }}
            </h3>

            <div
              v-if="view_selected === 'live'"
              class="tab-column"
            >
              <table>
                <thead>
                  <tr class="hltab borderless">
                    <th class="nr-col">#</th>
                    <th>{{ $t('timelog.fields.name') }}</th>
                    <th class="longcol">{{ $t('main.production') }}</th>
                    <th>{{ $t('timelog.fields.task_type') }}</th>
                    <th class="longcol">{{ $t('timelog.fields.task') }}</th>
                    <th>{{ $t('timelog.fields.software') }}</th>
                    <th>{{ $t('timelog.fields.workstation') }}</th>
                    <th>{{ $t('timelog.fields.last_seen') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(line, person, ind) in live_tab"
                    :class="{
                      inactive: line.last_seen !== line.last_active
                    }"
                  >
                    <td class="nr-col">{{ ind }}</td>
                    <td>{{ person }}</td>
                    <td class="longcol">
                      <p v-for="tsk in line.tasks">{{ tsk.production }}</p>
                    </td>
                    <td>
                      <p v-for="tsk in line.tasks">{{ tsk.task.split('/').slice(-1)[0] }}</p>
                    </td>
                    <td class="longcol">
                      <p v-for="tsk in line.tasks">{{ tsk.task }}</p>
                    </td>
                    <td>
                      <p v-for="tsk in line.tasks">{{ tsk.software }}</p>
                    </td>
                    <td v-if="line.tasks.length > 0">
                      <p v-for="tsk in line.tasks">{{ tsk.workstation }}</p>
                    </td>
                    <td v-else>
                      <p v-for="plc in line.places">{{ plc }}</p>
                    </td>
                    <td>{{ line.last_active }}</td>
                  </tr>
                </tbody>
              </table>

            </div>

            <div
              v-if="view_selected === 'productions'"
              class="tab-column"
            >
              <div>
                <table
                  v-for="(prod, prodname) in table"
                  :key="'tab' + prodname"
                >
                  <thead>
                    <tr class="hltab borderless">
                      <td class="nr-col"></td>
                      <td :colspan="projnamecolspan">
                        {{ prodname }}
                      </td>
                      <td v-if="table_sum > 0">{{ (100 * prod.total.minutes / table_sum).toFixed(1) }} %</td>
                      <td v-else>---</td>
                    </tr>
                    <tr>
                      <th class="nr-col">#</th>
                      <th
                        v-if="mode_selected !== 'productions'"
                        class="lon"
                      >
                        {{ $t('timelog.fields.task_type') }}
                      </th>
                      <th>{{ $t('timelog.fields.pers_h') }}</th>
                      <th>{{ $t('timelog.fields.workers') }}</th>
                      <th>{{ $t('timelog.fields.workdays') }}</th>
                      <th>{{ $t('timelog.fields.workers_per_day') }}</th>
                      <th>{{ $t('timelog.fields.portion') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(line, lineid, lineind) in prod.lines"
                      :key="'tabrow' + prodname + lineid"
                    >
                      <td class="nr-col">{{ lineind + 1 }}</td>
                      <td
                        v-if="mode_selected !== 'productions'"
                        class="lon"
                      >
                        {{ line.name }}
                      </td>
                      <td>{{ (line.minutes / 60).toFixed(1) }}</td>
                      <td>{{ line.workers.length }}</td>
                      <td>{{ line.days.length }}</td>
                      <td v-if="prod.total.days.length > 0">{{ (line.workers.length / line.days.length).toFixed(1) }}</td>
                      <td v-else>---</td>
                      <td v-if="prod.total.minutes > 0">{{ (100 * line.minutes / prod.total.minutes).toFixed(1) }} %</td>
                      <td v-else>---</td>
                    </tr>
                  </tbody>
                  <tfoot v-if="mode_selected !== 'productions'">
                    <tr>
                      <td class="nr-col"></td>
                      <td
                        v-if="mode_selected !== 'productions'"
                      ></td>
                      <td>{{ (prod.total.minutes / 60).toFixed(1) }}</td>
                      <td>{{ prod.total.workers.length }}</td>
                      <td>{{ prod.total.days.length }}</td>
                      <td v-if="prod.total.days.length > 0">{{ (prod.total.workers.length / prod.total.days.length).toFixed(1) }}</td>
                      <td v-else>---</td>
                      <td>100.0 %</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <div
              v-if="view_selected === 'attendance' && !pers_selected"
              class="tab-column"
            >
              <table
                v-for="(prod, prodname, prodind) in table"
                :key="'tab' + prodname"
              >
                <thead v-if="prodind === 0">
                  <tr>
                    <th
                      class="fillcorner"
                      colspan="3"
                    ></th>
                    <th
                      v-for="pers in pers_list"
                      class="narrow"
                      rowspan="2"
                      :key="'tabcolhead' + prodname + pers"
                    >
                      {{ pers }}
                    </th>
                  </tr>
                  <tr>
                    <th class="nr-col">#</th>
                    <th>{{ $t('timelog.fields.day') }}</th>
                    <th>{{ $t('timelog.fields.date') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(line, lineid) in prod.lines"
                    :key="'tabrow' + prodname + lineid"
                  >
                    <td class="nr-col">{{ line.nr }}</td>
                    <td>
                      {{ line.day }}
                    </td>
                    <td>{{ line.date }}</td>
                    <td
                      v-for="(col, colind) in line.columns"
                      class="narrow"
                      :key="'tabcol' + prodname + colind"
                    >
                      {{ (col / 60).toFixed(1) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="nr-col"></td>
                    <td
                      colspan="2"
                    ></td>
                    <td class="narrow">{{ (prod.total.minutes / 60).toFixed(1) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div
              v-if="view_selected === 'attendance' && mode_selected === 'employees' && pers_selected"
              class="tab-column"
            >
              <table
                v-for="(prod, prodname, prodind) in table"
                :key="'tab' + prodname"
              >
                <thead v-if="prodind === 0">
                  <tr>
                    <th class="nr-col">#</th>
                    <th>{{ $t('timelog.fields.day') }}</th>
                    <th>{{ $t('timelog.fields.date') }}</th>
                    <th>{{ $t('timelog.attendance') }}</th>
                    <th>{{ $t('timelog.fields.total') }}</th>
                    <th>{{ $t('timelog.fields.workhours') }}</th>
                    <th class="longcol">{{ $t('main.production') }}</th>
                    <th>{{ $t('timelog.fields.task_type') }}</th>
                    <th>{{ $t('timelog.fields.pers_h') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(line, lineid) in prod.lines"
                  >
                    <tr
                      v-for="(subline, ttid, slindex) in line.tasks"
                      :key="'tabrow' + line.date + ttid"
                    >
                      <template v-if="slindex === 0">
                        <td :rowspan="Object.keys(line.tasks).length" class="nr-col">{{ line.nr }}</td>
                        <td :rowspan="Object.keys(line.tasks).length">{{ line.day }}</td>
                        <td :rowspan="Object.keys(line.tasks).length">{{ line.date }}</td>
                        <td :rowspan="Object.keys(line.tasks).length">{{ fromToStr(line) }}</td>
                        <td :rowspan="Object.keys(line.tasks).length">{{ (line.minutes / 60).toFixed(1) }}</td>
                        <td :rowspan="Object.keys(line.tasks).length">{{ (line.work_minutes / 60).toFixed(1) }}</td>
                      </template>
                      <td class="wrapcell longcol">{{ subline.project }}</td>
                      <td>{{ subline.task_type }}</td>
                      <td>{{ 'minutes' in subline ? (subline.minutes / 60).toFixed(1) : '' }}</td>
                    </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="nr-col"></td>
                    <td
                      colspan="4"
                    ></td>
                    <td>{{ (prod.total.minutes / 60).toFixed(1) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import PageTitle from '@/components/widgets/PageTitle'
import TreeIndent from '@/components/widgets/TreeIndent'
import ButtonSimple from '@/components/widgets/ButtonSimple'
import Combobox from '@/components/widgets/Combobox'
import Checkbox from '@/components/widgets/Checkbox'

import moment from 'moment-timezone'

export default {
  name: 'timelog',

  components: {
    Combobox,
    Checkbox,
    Datepicker,
    PageTitle,
    TreeIndent,
    ButtonSimple
  },

  data() {
    return {
      raw_logs: [],
      expanded: {
        employees: false,
        task_types: false,
        departments: false,
        productions: false
      },
      start_selected: null,
      end_selected: null,
      start_date: moment().startOf('month').toString(),
      end_date: moment().toString(),
      view_selected: 'live',
      view_options: [
        { label: this.$t('timelog.live'), value: 'live' },
        { label: this.$t('timelog.productions'), value: 'productions' },
        { label: this.$t('timelog.attendance'), value: 'attendance' }
      ],
      pers_selected: false,
      pers_options: [{label: '---', value: false}],
      pers_list: [],
      prod_selected: false,
      prod_options: [{label: '---', value: false}],
      show_todos: true,
      table: {},
      live_tab: {},
      table_sum: 0
    }
  },

  computed: {
    ...mapGetters([
      'productions',
      'productionMap',
      'people',
      'personMap',
      'taskTypes',
      'taskTypeMap',
      'departments',
      'departmentMap',
      'taskMap',
      'entityMap',
    ]),

    mode_selected () {
      if (this.view_selected === 'attendance') {
        return 'employees'
      } else if (this.show_todos) {
        return 'task_types'
      } else {
        return 'productions'
      }
    },

    secondHead () {
      var worker = this.$t('main.all')
      var project = this.$t('main.all')
      if (this.prod_selected) {
        project = this.prod_selected
      }
      if (this.pers_selected) {
        worker = this.pers_selected
      }
      return `(${this.$t('people.title')}: ${worker} - ${this.$t('productions.title')}: ${project})`
    },

    projnamecolspan () {
      return this.mode_selected === 'productions' ? 4 : 5
    }
  },

  methods: {
    ...mapActions([
      'loadTimelog',
      'loadProductions',
      'loadDepartments',
      'loadTaskTypes',
      'loadPeople',
      'loadTask'
    ]),

    rint (a, b) {
      return a + Math.floor(Math.random() * (1 + b - a))
    },

    ristr (a, b) {
      var res = this.rint(a, b)
      if (res < 10) {
        return '0' + res.toString()
      } else {
        return res.toString()
      }
    },

    bigDate (d) {
      return d ? moment(d).format('dddd, DD.MM.YYYY') : ' - '
    },

    fromToStr (line) {
      const f = line.start ? line.start.format('HH:mm') : ''
      const t = line.end ? line.end.format('HH:mm') : ''
      return f + ' - ' + t
    },

    timeLessThan (a, b) {
      return moment(a, 'HH:mm:ss').isBefore(moment(b, 'HH:mm:ss'))
    },

    rangeToMin (strt, end) {
      return moment(end, 'HH:mm:ss').diff(moment(strt, 'HH:mm:ss'), 'minutes')
    },

    isExpanded (cat, id = '') {
      if (this.expanded[cat + id]) {
        return true
      }
      return false
    },

    toggleCollapse (treekey) {
      this.expanded[treekey] = this.expanded[treekey] ? false : true
    },

    re_load () {
      if (moment(this.start_date) <= moment(this.end_date)) {
        this.loadTimelog({
          start_date: this.start_date,
          end_date: this.end_date
        }).then(logs => {
          // this.raw_logs = logs.sort((a, b) => { return moment(a.day).isBefore(moment(b.day)) })
          this.raw_logs = logs
          this.re_table()
        })
      }
    },

    projTableLine (table, tabname, lineid, name, addMinutes, worker, day) {
      if (!(tabname in table)) {
        table[tabname] = {
          lines: {},
          total: {
            minutes: 0,
            workers: [],
            days: []
          }
        }
      }
      if (lineid in table[tabname].lines) {
        table[tabname].lines[lineid].minutes += addMinutes
        if (!table[tabname].lines[lineid].workers.includes(worker)) {
          table[tabname].lines[lineid].workers.push(worker)
        }
        if (!table[tabname].lines[lineid].days.includes(day)) {
          table[tabname].lines[lineid].days.push(day)
        }
      } else {
        table[tabname].lines[lineid] = {
          name, 
          minutes: addMinutes,
          workers: [worker],
          days: [day]
        }
      }
      table[tabname].total.minutes += addMinutes
      if (!table[tabname].total.workers.includes(worker)) {
        table[tabname].total.workers.push(worker)
      }
      if (!table[tabname].total.days.includes(day)) {
        table[tabname].total.days.push(day)
      }
    },

    attendTableLine (table, cols, colid, addMinutes, day) {
      const lineid = day
      var tabname = 0
      while (tabname in table) {
        tabname += 1
      }
      if (tabname > 0) {
        tabname -= 1
      }
      if (tabname in table) {
        for (const lday in table[tabname].lines) {
          if (moment(lday).weekday() < moment(day).weekday()) {
            tabname += 1
            break
          }
        }
      }

      if (!(tabname in table)) {
        table[tabname] = {
          lines: {},
          total: {
            minutes: 0
          }
        }
      }

      if (!(lineid in table[tabname].lines)) {
        table[tabname].lines[lineid] = {
          'day': moment(day).format('dddd'),
          date: moment(day).format('DD.MM.YYYY'),
          columns: []
        }
        for (const pers of cols) {
          table[tabname].lines[lineid].columns.push(0)
        }
      }

      const pind = cols.findIndex(p => p === colid)
      table[tabname].lines[lineid].columns[pind] += addMinutes
      table[tabname].total.minutes += addMinutes
    },

    personTableLine (table, day, start, end, proj_id, type_id) {
      const lineid = day
      var tabname = 0

      while (tabname in table) {
        if (!(day in table[tabname].lines)) {
          const firstOfWeek = moment(Object.keys(table[tabname].lines)[0]).weekday(1)
          if(firstOfWeek.isAfter(moment(day))) {
            tabname += 1
          } else {
            break
          }
        } else {
          break
        }
      }

      // while (tabname in table) {
      //   tabname += 1
      // }
      // tabname -= 1
      // if (tabname in table) {
      //   for (const lday in table[tabname].lines) {
      //     if (moment(lday).weekday() > moment(day).weekday()) {
      //       tabname += 1
      //       break
      //     }
      //   }
      // }

      if (!(tabname in table)) {
        table[tabname] = {
          lines: {},
          total: {
            minutes: 0
          }
        }
      }
      const addMinutes = this.rangeToMin(start, end)
      // const durStr = `${start.substring(0, 5)} - ${end.substring(0, 5)}`
      if (!(lineid in table[tabname].lines)) {
        table[tabname].lines[lineid] = {
          'day': moment(day).format('dddd'),
          date: moment(day).format('DD.MM.YYYY'),
          minutes: 0,
          start: null,
          end: null,
          // attendance: '9:00 - 17:00',
          work_minutes: 0,
          tasks: {
            '': {}
          }
        }
      }
      const line = table[tabname].lines[lineid]
      if (type_id === 'LOGIN') {
        const startmom = moment(start, 'HH:mm:ss')
        const endmom = moment(end, 'HH:mm:ss')
        if (!line.start || line.start.isAfter(startmom)) {
          line.start = startmom
        }
        if (!line.end || line.end.isBefore(endmom)) {
          line.end = endmom
        }
        line.minutes = line.end.diff(line.start, 'minutes')
      } else {
        if (!(type_id in line.tasks)) {
          line.tasks[type_id] = {
            project: proj_id,
            task_type: type_id,
            minutes: 0
          }
          if ('' in line.tasks) {
            delete line.tasks['']
          }
        }
        line.tasks[type_id].minutes += addMinutes
        table[tabname].total.minutes += addMinutes
        line.work_minutes += addMinutes
      }
    },

    re_table () {
      const now = moment()
      this.prod_options = [{label: '---', value: false}]
      this.pers_options = [{label: '---', value: false}]
      this.pers_list = []
      this.live_tab = {}

      for (const log of this.raw_logs) {
        const prs = log.person_name.split('@')[0]
        if (!this.pers_options.find(p => p.value === prs)) {
          this.pers_options.push({label: prs, value: prs})
          this.pers_list.push(prs)
        }
        if (log.task_name !== 'LOGIN') {
          const splt = log.task_name.split('://')
          const pn = splt.length > 1 ? splt[1].split('/')[0] : splt[0].split('/')[0]
          if (!this.prod_options.find(p => p.value === pn)) {
            this.prod_options.push({label: pn, value: pn})
          }
        }
      }
      var res = {}
      var sum = 0
      for (const log of this.raw_logs) {
        log.minutes = this.rangeToMin(log.start, log.last_active)
        const prs = log.person_name.split('@')[0]
        const wrk = log.person_name.split('@')[1]
        var tn = log.task_name
        var ap = tn.split('://')
        if (ap.length > 1) {
          tn = ap[1]
          ap = ap[0]
        } else {
          tn = ap[0]
          ap = ''
        }
        const sepInd = tn.indexOf('/')
        const pn = tn.substring(0, sepInd)
        tn = tn.substring(sepInd + 1)
        const tt = tn.split('/').slice(-1)[0]
        if (moment(log.day).isSame(moment(), 'day') && this.rangeToMin(log.last_seen, now) < 11) {
          if (!this.live_tab[prs]) {
            this.live_tab[prs] = {
              tasks: [],
              places: [],
              last_seen: null,
              last_active: null,
            }
          }
          if (!this.timeLessThan(log.last_seen, this.live_tab[prs].last_seen)) {
            this.live_tab[prs].last_seen = log.last_seen
            this.live_tab[prs].last_active = log.last_active
          }

          if (log.task_name !== 'LOGIN') {
            this.live_tab[prs].tasks.push(
              {
                production: pn,
                software: ap,
                task: tn,
                workstation: wrk || '',
              }
            )
          } else {
            this.live_tab[prs].places.push(wrk)
          }
        }
        if (this.view_selected === 'productions') {
          if (log.task_name === 'LOGIN') { continue }
          if (this.prod_selected && this.prod_selected !== pn) { continue }
          if (this.pers_selected && this.pers_selected !== prs) { continue }
          switch (this.mode_selected) {
            case 'productions':
              this.projTableLine(res, pn, '', '', log.minutes, prs, log.day)
              break
            case 'task_types':
              this.projTableLine(res, pn, tt, tt, log.minutes, prs, log.day)
              break
            case 'employees':
              this.projTableLine(res, pn, prs, prs, log.minutes, prs, log.day)
              break
            default:
              this.projTableLine(res, pn, 'other', 'other', log.minutes, prs, log.day)
          }
          sum += log.minutes

        } else if (this.view_selected === 'attendance' && this.mode_selected === 'employees') {
          if (!this.pers_selected && log.task_name === 'LOGIN') {
            this.attendTableLine (res, this.pers_list, prs, log.minutes, log.day)
            sum += log.minutes
          } else if (this.pers_selected === prs) {
            this.personTableLine(res, log.day, log.start, log.last_active, pn, tt)
            sum += log.minutes
          }
        }
      }
      if (this.view_selected === 'attendance' && this.mode_selected === 'employees') {
        var ind = 1
        for (const tabnr in res) {
          for (const lineid in res[tabnr].lines) {
            res[tabnr].lines[lineid].nr = ind
            ind += 1
          }
        }
      }
      this.table = res
      this.table_sum = sum
    },

    onPrintClick () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const html = document.getElementById('table-area').innerHTML
          var css = ''
          for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            css += node.outerHTML
          }
          const win = window.open(`${window.location.origin}/loadPrint.html`, 'print_timelog', 'hieght=600,width=1000')
          const ping = setInterval(() => {
            win.postMessage({ data: { html, css } })
          }, 100)
          win.addEventListener('message', ({ data }) => {
            if (data === 'recieved') {
              clearInterval(ping)
            }
          })
          win.focus()
          win.print()
        })
      })
    },
  },

  watch: {
    start_selected () {
      this.start_date = moment(this.start_selected).format('YYYY-MM-DD')
      this.re_load()
    },
    end_selected () {
      this.end_date = moment(this.end_selected).format('YYYY-MM-DD')
      this.re_load()
    },

    view_selected () {
      this.re_table()
    },

    prod_selected () {
      this.re_table()
    },

    pers_selected () {
      this.re_table()
    },

    mode_selected () {
      this.re_table()
    }
  },

  created() {
    this.loadProductions()
    this.loadDepartments()
    this.loadTaskTypes()
    this.loadPeople()
    this.start_selected = this.start_date
    this.end_selected = this.end_date
  },

  mounted () {
    this.re_load()
  },

  metaInfo() {
    return {
      title: `${this.$t('timelog.title')} - Kitsu`
    }
  }
}
</script>

<style lang="scss" scoped>
.side-column {
  width: 700px;
  min-width: 700px;
}

.columns {
  height: 100%;
}

.nav-column {
  max-width: 350px;
}

tr {
  height: 10px;
}

.name-col{
  width: 300px;
}

.datepickrow {
  width: fit-content;
  margin: 30px auto 15px auto;
}

.mainrow {
  height: 75%;
  display: flex;
  justify-content: center;
}

.hltab {
  background-color: $grey;
  border: 1px solid $dark-grey;
}

table {
  background-color: $light-grey;
  max-height: 20px;
  margin-bottom: 1.5em;
  font-size: 10pt;
  th {
    text-align: center;
    background-color: $grey;
  }
  th, td {
    overflow: clip;
    padding: 0 4px 0 4px;
    color: $dark-grey;
    min-width: 100px;
    max-width: 100px;
    max-height: 10px;
    border: 1px solid $dark-grey;
  }
  tfoot * {
    border: none;
    font-weight: bold;
  }
}

.inactive>td {
  background-color: #e6e6e6;
}
.inactive {
  opacity: 0.7;
}


.longcol {
  min-width: 300px;
  max-width: 300px;
}

.lon {
  min-width: 200px;
  max-width: 200px;
}

.nr-col {
  min-width: 30px;
  max-width: 30px;
  width: 30px;
}

.dark {
  .inactive>td {
    background-color: #585858;
  }
  table {
    background-color: #383838;
    th {
      text-align: center;
      background: -webkit-gradient(linear,left top,left bottom,from(#515151),to(#2c2c2c));
      border: 2px solid #212225;
      color: $grey;
    }
    td {
      // border-color: $white;
      color: $light-grey;
      border: 2px solid #212225;
      background: #383838;
    }
  }
  .hltab>td {
    background: -webkit-gradient(linear,left top,left bottom,from(#515151),to(#383838));;
    border-color: #212225;
    color: $grey;
  }
}

:deep(.input[disabled]) {
  background: #9c9c9c;
  opacity: 0.5;
  color: $white;
}

:deep(select[disabled]:disabled) {
  background: #9c9c9c;
  opacity: 0.5;
  color: $white;
}

.borderless * {
  border: none;
}

.right_button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.left_button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.current {
  background-color: $green;
}

h2 {
  text-align: center;
  font-size: 1.6em;
  border: none;
  margin: 0;
}

h3 {
  text-align: center;
  font-size: 1em;
  margin-bottom: 1em;
}

.tab-column {
  padding-left: 4px;
  padding-right: 4px;
}

.field {
  margin: 0;
}

.wrapcell {
  word-wrap: break-word;
}

.table-area {
  max-width: fit-content;
}

.narrow {
  min-width: 45px;
  max-width: 45px;
}

th.narrow {
  height: 120px;
  writing-mode: vertical-lr;
  padding-top: 4px;
}

.fillcorner {
  height: 80px;
  background: #2f3135 !important;
}

@media print {
  th, td {
    border: 2px solid black !important;
  }
}
</style>
